import Constants from './constants';
import methods from './helper';

export default {
    data() {
        return {
            consts: Constants,

        }
    },
    methods
}
